/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'avi-forms';
const componentName = 'config-field-input-validation';
const prefix = `${moduleName}.${componentName}`;

export const invalidValueMessage = `${prefix}.invalidValueMessage`;

export const ENGLISH = {
    [invalidValueMessage]: 'The value entered is invalid.',
};
